export default __webpack_public_path__ + "static/media/logo-masamune-full-black.50f6d489.svg";